<template>
  <div class="list-container">
    <div v-show="!form.visible">
      <div class="filter-container">
        <div class="filter-box">
          <span class="label">名称</span>
          <el-input
            v-model="paginationReq.name"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="getPage"
          />
        </div>
        <div class="filter-box">
          <span class="label">提成类型</span>
          <el-select :filterable="true" v-model="paginationReq.commissionType" class="filter-item" placeholder="" clearable @keyup.enter="getPage">
            <template v-if="commissionTypes.length">
              <el-option
                v-for="item in commissionTypes"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </div>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="getPage"
          >
            {{ t("table.search") }}
          </el-button>
          <!-- <el-button
            v-permission="{pkey:`${permissionName}_ADD`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button> -->
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCreateOrUpdate()"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
        </div>
      </div>
      <el-table
        ref="treeTable"
        v-loading="table.loading"
        :data="paginationRes.data"
        border
        fit
        row-key="id"
        highlight-current-row
        @current-change="handleRowChange"
        style="width: 100%">
        <el-table-column label="提成名称" min-width="180p x" prop="name"/>
        <el-table-column label="提成类型" min-width="180px" prop="commissionType" :formatter="formatCommissionType"/>
        <el-table-column label="提成比例" min-width="180px" prop="rate">
          <template #default="{ row }">
            <span>  {{ Number(row.rate * 100).toFixed() }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="业务金额下限" min-width="180px" prop="min">
          <template #default="{ row }">
            <span>  {{ null == row.min ? '' : Number(row.min / 10000).toFixed() + '万元' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业务金额下限" min-width="180px" prop="max">
          <template #default="{ row }">
            <span>  {{ null == row.max ? '' : Number(row.max / 10000).toFixed() + '万元' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="t('table.actions')"
          align="center"
          min-width="180px"
          class-name="fixed-width"
        >
          <template #default="{ row }">
            <el-link
              v-permission="{ pkey: `${permissionName}_EDIT` }"
              href="javascript:void(0);"
              class="mr-10"
              type="primary"
              @click="handleEdit(row)"
            >
              {{ t("table.edit") }}
            </el-link>
            <el-link
              v-permission="{ pkey: `${permissionName}_DELETE` }"
              href="javascript:void(0);"
              type="danger"
              @click="handleDelete(row)"
            >
              {{ t("table.delete") }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-dialog
        :title="form.title"
        v-model="form.visible"
      > -->
    </div>
    <div class="dataForm" v-show="form.visible">
      <el-form
        ref="dataForm"
        :rules="form.rules"
        :model="commission"
        label-position="top"
        label-width="100px"
      >
      <div class="form-title">
        <span class="label blue" >基</span>
        <span class="left">基本信息</span>
      </div>
      <div class="underlineForm">
        <el-form-item
          label="提成名称"
          prop="name"
          clearabl>
          <el-input v-model="commission.name" placeholder="如:业务员50-70万提成"/>
        </el-form-item>
        <el-form-item label="提成类型" prop="commissionType">
          <el-select :filterable="true" v-model="commission.commissionType" class="filter-item" placeholder="输入关键字搜索">
            <template v-if="commissionTypes.length">
              <el-option
                v-for="item in commissionTypes"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="提成比例"
          prop="rate"
          clearabl>
          <el-input type="number" v-model="commission.rate" placeholder="如:20%">
            <template #append>%</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="此提成下限"
          prop="min"
          clearabl>
          <el-input type="number" v-model="commission.min" placeholder=" ">
            <template #append>万元</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="此提成上限"
          prop="max"
          clearabl>
          <el-input type="number" v-model="commission.max" placeholder=" ">
            <template #append>万元</template>
          </el-input>
        </el-form-item>
      </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="form.visible = false">
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          @click="save"
        >
          {{ t("table.confirm") }}
        </el-button>
      </div>
      </div>
    <!-- </el-dialog> -->
    <el-pagination
      v-show="paginationRes.total > 0"
      :total="paginationRes.total"
      v-model:currentPage="paginationReq.page"
      :page-size="paginationReq.size"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next"
    />
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n'
import { nextTick, onMounted, reactive, ref, toRefs, unref } from 'vue'
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { CommissionPaginationRequest, CommissionResponse } from '@/model/commission'
import { Pagination } from '@/model/Pagination'
import { DropdownOptionModel, getDropdownByType } from '@/apis/tool'
import { create, findById, page, update, deleteByIds } from '@/apis/CommissionApi'
import { cloneDeep } from 'lodash'
import { permissionName } from '@/utils/enum'

export default {
  name: 'Commission',
  setup() {
    const { t } = useI18n()
    const dataForm = ref(ElForm)
    const defaultCommission: CommissionResponse = {
      id: undefined,
      name: '',
      commissionType: 1,
      rate: 0,
      min: undefined,
      max: undefined
    }
    // 新增/编辑的对象
    const commission = cloneDeep(defaultCommission)
    // 分页request
    const paginationReq: CommissionPaginationRequest = {
      name: '',
      commissionType: undefined,
      page: 1,
      size: 10
    }
    // 分页response
    const paginationRes: Pagination<CommissionResponse> = {
      page: 0,
      total: 0,
      data: []
    }
    const commissionTypes: DropdownOptionModel[] = []
    const refs = reactive({
      permissionName: permissionName.COMMISSION,
      selectedId: 0,
      commission,
      paginationReq,
      paginationRes,
      commissionTypes,
      table: {
        loading: false
      },
      form: {
        title: '',
        visible: false,
        loading: false,
        rules: {
          name: [{ required: true, message: '请输入提成名称', trigger: 'change' }],
          commissionType: [{ required: true, message: '请选择提成类型', trigger: 'change' }],
          rate: [{ required: true, message: '请输入汇率', trigger: 'change' }]
        },
        titles: {
          create: '新建',
          update: '编辑'
        }
      },
      async handleCreateOrUpdate(id?: number): Promise<void> {
        if (id) {
          const result = await findById(id)
          if (result.min) {
            result.min = result.min / 10000
          }
          if (result.max) {
            result.max = result.max / 10000
          }
          result.rate = result.rate * 100

          refs.commission = result
          refs.form.title = refs.form.titles.update
        } else {
          refs.commission = cloneDeep(defaultCommission)
          refs.form.title = refs.form.titles.create
        }
        refs.form.visible = true
        await nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      handleRowChange(row: CommissionResponse) {
        refs.selectedId = row?.id || 0
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteByIds(row.id).then(() => {
              refs.getPage()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      async handleEdit(row: any): Promise<void> {
        const _id = refs.selectedId || row.id
        if (_id) {
          await refs.handleCreateOrUpdate(_id)
        }
      },
      async save(): Promise<void> {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const requestData = cloneDeep(refs.commission)
            if (requestData.min) {
              requestData.min = requestData.min * 10000
            }
            if (requestData.max) {
              requestData.max = requestData.max * 10000
            }
            requestData.rate = requestData.rate / 100

            refs.form.loading = true
            let promise: Promise<void>
            if (requestData.id) {
              promise = update(requestData.id, requestData)
            } else {
              promise = create(requestData)
            }
            promise.then(async() => {
              ElMessage({
                message: '保存成功',
                type: 'success',
                duration: 2000
              })
              refs.form.visible = false
              await refs.getPage()
            }).finally(() => {
              refs.form.loading = false
            })
          }
        })
      },
      async getCommissionTypes(): Promise<void> {
        refs.commissionTypes = await getDropdownByType('CommissionType')
      },
      async getCommissionById(id: number): Promise<void> {
        refs.commission = await findById(id)
      },
      async getPage(): Promise<void> {
        refs.table.loading = true
        page(refs.paginationReq).then(res => {
          refs.paginationRes = res
        }).finally(() => {
          refs.table.loading = false
        })
      },
      handleReset() {
        refs.paginationReq = {
          name: '',
          commissionType: undefined,
          page: 1,
          size: 10
        }
        refs.getPage()
      },
      formatCommissionType(row: CommissionResponse, column: any, cellValue: number): string {
        const find = refs.commissionTypes.find(item => item.id === cellValue)
        if (find) {
          return find.mark
        }
        return ''
      },
      handleCurrentChange(page: number): void {
        refs.paginationReq.page = page
        refs.getPage()
      },
      handleSizeChange(size: number): void {
        refs.paginationReq.size = size
        refs.handleCurrentChange(1)
      }
    })
    onMounted(() => {
      refs.getCommissionTypes()
      refs.getPage()
    })
    return { t, ...toRefs(refs), dataForm }
  }
}
</script>

<style scoped>

</style>
